/* tslint:disable */
/* eslint-disable */
/**
 * CyberWell Aegis API
 * Multi-tenant case management API with JWT auth, RBAC (Casbin), audit logging, and tenant isolation.
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CreateInitiativeFromFindingRequest
 */
export interface CreateInitiativeFromFindingRequest {
    /**
     * 
     * @type {string}
     * @memberof CreateInitiativeFromFindingRequest
     */
    findingId: string;
    /**
     * 
     * @type {string}
     * @memberof CreateInitiativeFromFindingRequest
     */
    findingTitle: string;
    /**
     * 
     * @type {string}
     * @memberof CreateInitiativeFromFindingRequest
     */
    findingSummary?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateInitiativeFromFindingRequest
     */
    profileId?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateInitiativeFromFindingRequest
     */
    ownerUserId?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateInitiativeFromFindingRequest
     */
    drivenBy?: string;
    /**
     * 
     * @type {number}
     * @memberof CreateInitiativeFromFindingRequest
     */
    budgetAllocated?: number;
    /**
     * 
     * @type {string}
     * @memberof CreateInitiativeFromFindingRequest
     */
    budgetCurrency?: string;
    /**
     * 
     * @type {Date}
     * @memberof CreateInitiativeFromFindingRequest
     */
    targetDate?: Date;
    /**
     * 
     * @type {number}
     * @memberof CreateInitiativeFromFindingRequest
     */
    priorityRank?: number;
    /**
     * 
     * @type {string}
     * @memberof CreateInitiativeFromFindingRequest
     */
    effectTenantId?: string;
}

/**
 * Check if a given object implements the CreateInitiativeFromFindingRequest interface.
 */
export function instanceOfCreateInitiativeFromFindingRequest(value: object): value is CreateInitiativeFromFindingRequest {
    if (!('findingId' in value) || value['findingId'] === undefined) return false;
    if (!('findingTitle' in value) || value['findingTitle'] === undefined) return false;
    return true;
}

export function CreateInitiativeFromFindingRequestFromJSON(json: any): CreateInitiativeFromFindingRequest {
    return CreateInitiativeFromFindingRequestFromJSONTyped(json, false);
}

export function CreateInitiativeFromFindingRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateInitiativeFromFindingRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'findingId': json['findingId'],
        'findingTitle': json['findingTitle'],
        'findingSummary': json['findingSummary'] == null ? undefined : json['findingSummary'],
        'profileId': json['profileId'] == null ? undefined : json['profileId'],
        'ownerUserId': json['ownerUserId'] == null ? undefined : json['ownerUserId'],
        'drivenBy': json['drivenBy'] == null ? undefined : json['drivenBy'],
        'budgetAllocated': json['budgetAllocated'] == null ? undefined : json['budgetAllocated'],
        'budgetCurrency': json['budgetCurrency'] == null ? undefined : json['budgetCurrency'],
        'targetDate': json['targetDate'] == null ? undefined : (new Date(json['targetDate'])),
        'priorityRank': json['priorityRank'] == null ? undefined : json['priorityRank'],
        'effectTenantId': json['effectTenantId'] == null ? undefined : json['effectTenantId'],
    };
}

export function CreateInitiativeFromFindingRequestToJSON(json: any): CreateInitiativeFromFindingRequest {
    return CreateInitiativeFromFindingRequestToJSONTyped(json, false);
}

export function CreateInitiativeFromFindingRequestToJSONTyped(value?: CreateInitiativeFromFindingRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'findingId': value['findingId'],
        'findingTitle': value['findingTitle'],
        'findingSummary': value['findingSummary'],
        'profileId': value['profileId'],
        'ownerUserId': value['ownerUserId'],
        'drivenBy': value['drivenBy'],
        'budgetAllocated': value['budgetAllocated'],
        'budgetCurrency': value['budgetCurrency'],
        'targetDate': value['targetDate'] == null ? undefined : ((value['targetDate']).toISOString().substring(0,10)),
        'priorityRank': value['priorityRank'],
        'effectTenantId': value['effectTenantId'],
    };
}

